<template>
  <v-app >
   <!-- <router-link to="/" exact></router-link>
    <router-link to="/landing" exact></router-link> -->
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
 
 
};
</script>